module["exports"] = [
  "Appartamento ##",
  "Piano #"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/secondary_address.js
// module id = 1777
// module chunks = 0